import { useEffect, useRef } from "react";

/**
 * Como `setInterval`, pero **no dispara con la pestaña en segundo plano**, y
 * refresca en cuanto se vuelve a mirar.
 *
 * Existe por el atasco del 08-09-2026 (BE #612). El panel `/ops` se queda abierto
 * en una pestaña de fondo durante horas y preguntaba cada 30 s pasara lo que
 * pasara. Cada llamada retenía una conexión de base de datos durante el fan-out a
 * GitHub y AWS —unos 3 s—, o sea ~120 conexiones-hora por pestaña olvidada. Con 30
 * conexiones en el pool, eso fue una de las piezas que dejaron al dispensario
 * haciendo cola.
 *
 * El refresco al volver no es un extra: sin él se vería hasta 30 s de estado viejo
 * justo cuando alguien vuelve a la pestaña para decidir un despliegue.
 *
 * @param {Function} fn  qué hacer. Debe ser estable (useCallback).
 * @param {number} ms    cada cuánto, mientras se mire.
 */
export function useIntervaloVisible(fn, ms) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    const siSeMira = () => {
      if (!document.hidden) fnRef.current();
    };

    siSeMira();
    const id = setInterval(siSeMira, ms);
    document.addEventListener("visibilitychange", siSeMira);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", siSeMira);
    };
  }, [ms]);
}
